<template>
  <div class="body">
    <el-card class="box_card">
      <div class="card-content">
        <div class="header flex flex-middle">
          <div @click="goBackList" class="flex flex-middle header-l">
            <i class="iconfont icontuichu"></i>
            <span class="bold">返回健康档案</span>
          </div>
        </div>
        <div class="main-content">
          <!-- info -->
          <div class="info-box">
            <div class="info-box-t flex flex-middle">
              <div class="info-box-t-l bold">
                <span style="font-size: 24px">{{ patientInfo.cml_full_name ? patientInfo.cml_full_name : '' }}</span>
                <span>
                  | {{ patientInfo.cml_Gender ? patientInfo.cml_Gender : '' }} |
                  {{ patientInfo.cml_Age ? patientInfo.cml_Age : '' }}岁</span
                >
              </div>
              <div class="flex flex-middle flex-wrap tag-box">
                <div v-for="(tag, k1) in tagList" :key="k1" class="tag-items">{{ tag.glol_name }}</div>
              </div>
            </div>
            <div class="flex flex-middle info-box-b">
              <div class="flex flex-middle info-box-b-l">
                <img src="@/assets/img/idcard.png" class="idcardImg" />
                <span class="big">{{ patientInfo.cml_Customer_ID ? patientInfo.cml_Customer_ID : '' }}</span>
              </div>
              <div class="flex flex-middle">
                <img src="@/assets/img/phone.png" class="phoneImg" />
                <span class="big">{{ patientInfo.cml_mobile_phone ? patientInfo.cml_mobile_phone : '' }}</span>
              </div>
            </div>
          </div>
          <!-- 健康档案 -->
          <div class="report-box flex">
            <div class="report-box-item">
              <div class="report-box-title bold">健康档案（{{ healthRecordsList.length ? healthRecordsList.length : 0 }}）</div>
              <div class="report-box-bottom">
                <el-collapse>
                  <el-collapse-item name="1" v-for="(item, d) in healthRecordsList" :key="d">
                    <template #title>
                      <div class="flex flex-column" style="width: 80%">
                        <div>{{ moment(item.Creationtime).format('YYYY年MM月DD日 HH:mm:ss') }}</div>
                        <div class="ellipsis">【主诉】：{{ item.cmhr_Main_complaint_content }}</div>
                      </div>
                    </template>
                    <div>
                      <el-image style="width: 100px; height: 100px; margin: 10px" :src="url" :preview-src-list="srcList"> </el-image>
                      <el-image style="width: 100px; height: 100px; margin: 10px" :src="url" :preview-src-list="srcList"> </el-image>
                      <el-image style="width: 100px; height: 100px; margin: 10px" :src="url" :preview-src-list="srcList"> </el-image>
                      <el-image style="width: 100px; height: 100px; margin: 10px" :src="url" :preview-src-list="srcList"> </el-image>
                      <el-image style="width: 100px; height: 100px; margin: 10px" :src="url" :preview-src-list="srcList"> </el-image>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
            <!-- 健康档案 -->
            <div class="report-box-item">
              <div class="report-box-title bold">检验报告（{{ orderRecordsList.length ? orderRecordsList.length : 0 }}）</div>
              <div class="report-box-bottom">
                <div
                  v-for="(item2, k2) in orderRecordsList"
                  :key="k2"
                  class="flex flex-middle flex-between list-items"
                  @click="lookDetail(item2)"
                >
                  <div class="flex-one flex flex-column" style="width: 70%">
                    <div>
                      <span class="times bold">{{ moment(item2.Creationtime).format('YYYY年MM月DD日 HH:mm:ss') }}</span>
                      <span :class="item2.orsl_Report_status === '报告已出' ? 'tag2-active' : 'tag2'">{{
                        item2.orsl_Report_status ? item2.orsl_Report_status : ''
                      }}</span>                    
                      <span  v-if="item2.orsl_Whether_to_interpret=='是'" style="margin-left:10px;" >                     
                         <span class="tag2-active" v-if="item2.orsl_Interpretation_state=='已总检' ">已总检 </span>
                         <span class="tag2" v-if="!item2.orsl_Interpretation_state">未总检 </span>
                      </span>
                    </div>
                    <div class="times bold" style="margin-top: 5px">
                      订单编号：<span style="color: orange"> {{ item2.DocumentNo ? item2.DocumentNo : '' }}</span>
                    </div>
                    <div class="contents">
                      <span v-for="(col, ckey) in item2.Order_detail_Library" :key="ckey">{{ col.psl_name }}；</span>
                    </div>
                  </div>
                  <div @click.stop="clickPdf(item2.orsl_Report_address)" style="cursor: pointer">
                    <img src="@/assets/img/report1.png" />
                  </div>
                </div>
              </div>
            </div>
            <!-- 疾病风险报告 -->
            <div class="report-box-item">
              <div class="report-box-title bold">疾病风险报告（{{ risksReportList.length ? risksReportList.length : 0 }}）</div>
              <div class="report-box-bottom">
                <div
                  v-for="(val, k3) in risksReportList"
                  :key="k3"
                  class="flex flex-middle flex-between list-items"
                  style="background: #f3eaff"
                >
                  <div class="flex-one flex flex-column" style="width: 70%">
                    <div>
                      <span class="times bold">{{ moment(val.Creationtime).format('YYYY年MM月DD日 HH:mm:ss') }}</span>
                      <span class="tag">未使用</span>
                    </div>
                    <div class="contents">{{ val.Disd_Name_of_disease }}</div>
                  </div>
                  <div @click="goDiseaseRisk()" style="cursor: pointer">
                    <img src="@/assets/img/tip.png" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-dialog :visible.sync="dialogVisible" width="327px" :show-close="false" top="280px">
            <div class="dialog-box flex flex-center">
              <img src="@/assets/img/PatientFilesreport.png" />
              <div class="dialog-text">报告未出！</div>
            </div>
          </el-dialog>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import request from '@/utils/request';
import moment from 'moment';
export default {
  name: 'PatientFiles',
  data() {
    return {
      moment: moment,
      customerId: '',
      patientInfo: {}, //患者基本信息
      tagList: [], //患者标签
      healthRecordsList: [], //健康档案列表
      orderRecordsList: [], //检验报告
      risksReportList: [], //疾病风险报告
      url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
      srcList: [
        'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
        'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'
      ],
      dialogVisible: false
    };
  },
  created() {
    this.customerId = this.$route.query.customerId;
    // console.log('路由传参的customerId：：', this.customerId);
    this.getPatientInfo(); //患者基本信息
    this.getHealthRecords(); //健康档案
    this.getOrderRecords(); //检验报告
    this.getRisksReport(); //疾病风险报告
  },
  mounted() {
    var that = this;
  },
  methods: {
    // 点击pdf报告
    clickPdf(path) {
      if (!path) {
        this.dialogVisible = true;
        setTimeout(() => {
          this.dialogVisible = false;
        }, 1000);
      } else {
        window.open(path, '_blank');
      }
    },
    //获取患者的基本信息
    getPatientInfo() {
      const that = this;
      const clinicInfo = JSON.parse(sessionStorage.user);
      let dataP = {
        cal_code: clinicInfo.hsp_code,
        cml_Customer_ID: that.customerId
      };
      const params = {
        workid: 'e575201c-59b5-4c10-ebc7-103c830f6c49',
        data: JSON.stringify(dataP)
      };
      request
        .post('/server/getdatalisapi.php', params)
        .then((res) => {
          // console.log('病人详情：：', res.Channel_customer_relationship[0]);
          that.patientInfo = res.Channel_customer_relationship[0];
          that.tagList = res.Channel_customer_relationship[0].Customer_tag_library;
        })
        .catch((err) => {
          that.$message.error('抱歉，获取病人信息失败');
        });
    },
    //  获取健康档案
    getHealthRecords() {
      const that = this;
      const clinicInfo = JSON.parse(sessionStorage.user);
      let dataP = {
        cal_code: clinicInfo.hsp_code,
        cml_Customer_ID: that.customerId
      };
      const params = {
        token: clinicInfo.token,
        workid: '2251bd19-9aba-22c6-042d-28836935b3a8',
        data: JSON.stringify(dataP)
      };
      request
        .post('/server/getdatalisapi.php', params)
        .then((res) => {
          that.healthRecordsList = res.Customer_health_records.reverse();
          // console.log('健康档案：：', that.healthRecordsList);
        })
        .catch((err) => {
          that.$message.error('抱歉，获取病人健康档案列表失败');
        });
    },
    //获取检验报告
    getOrderRecords() {
      const that = this;
      const clinicInfo = JSON.parse(sessionStorage.user);
      let dataP = {
        orsl_Consumer_ID_number: '',
        cml_Customer_ID: that.customerId
      };
      const params = {
        token: clinicInfo.token,
        workid: '3a2444a9-be1a-bdfb-e6ea-ebb64723e334',
        data: JSON.stringify(dataP)
      };
      request
        .post('/server/getdatalisapi.php', params)
        .then((res) => {
          that.orderRecordsList = res.Order_summary_Library.reverse();
          // console.log('检验报告：：', that.orderRecordsList);
        })
        .catch((err) => {
          that.$message.error('抱歉，获取病人检验报告列表失败');
        });
    },
    //获取疾病风险报告
    getRisksReport() {
      const that = this;
      const clinicInfo = JSON.parse(sessionStorage.user);
      let dataP = {
        cml_Customer_ID: that.customerId
      };
      const params = {
        token: clinicInfo.token,
        workid: 'bfb94e4a-4642-35e9-6b80-f67ebc8f86ef',
        data: JSON.stringify(dataP)
      };
      request
        .post('/server/getdatalisapi.php', params)
        .then((res) => {
          that.risksReportList = res.Customer_disease_risk_report.reverse();
          // console.log('检验报告：：', that.orderRecordsList);
        })
        .catch((err) => {
          that.$message.error('抱歉，获取病人疾病风险报告列表失败');
        });
    },
    //返回患者列表
    goBackList() {
      let vm = this;
      vm.$router.push({ path: '/patient', query: { name: '22222' } });
    },
    // 检验报告查看详情
    lookDetail(item) {
      localStorage.setItem('reportDetail', JSON.stringify(item)); //保存数据
      this.$router.push({ path: '/reportDetailCopy', query: { customerId: this.customerId, sorucePath: 'patientFiles' } });
    },
    goDiseaseRisk() {
      let vm = this;
      // vm.$router.push({ path: '/diseaseRisk', query: { name: '22222' } });
    },
    noReport() {
      this.dialogVisible = true;
      setTimeout(() => {
        this.dialogVisible = false;
      }, 1000);
    }
  }
};
</script>

<style scoped>
.report-box-bottom >>> .el-collapse-item__header {
  height: 110px !important;
  background-color: #eafeff;
  margin-bottom: 12px;
}
</style>

<style lang="scss" scoped>
.body {
  height: calc(100vh - 90px);
  width: 100%;
  // 去除卡片的padding
  ::v-deep .el-card__body {
    height: 100% !important;
    width: 100% !important;
    padding: 0px !important;
    border-radius: 30px 30px 0px 0px !important;
  }
  .box_card {
    // height  border-radius 和订单详情的样式统一
    height: 100%;
    margin-right: 30px;
    box-sizing: border-box;
    border-radius: 30px 30px 0px 0px !important;
    .card-content {
      height: 100%;
      box-sizing: border-box;

      .header {
        background: #f0feff;
        border-radius: 30px 30px 0px 0px;
        padding: 15px 0 15px 31px;

        .header-l {
          cursor: pointer;
          color: #2d99d7;
          font-size: 18px;
          i {
            font-size: 24px;
            margin-right: 11px;
          }
        }
      }

      .main-content {
        height: 100%;
        // overflow: auto;
        .info-box {
          padding: 22px 0 25px 30px;

          .info-box-t {
            align-items: flex-start;

            .info-box-t-l {
              color: #333;
              min-width: 180px;
            }

            .tag-box {
              margin-top: -10px;

              .tag-items {
                height: 30px;
                line-height: 30px;
                padding: 0 15px;
                display: inline-block;
                background: #d5f0ff;
                border-radius: 11px;
                font-size: 12px;
                color: #2d99d7;
                margin-right: 10px;
                margin-top: 10px;
              }
            }
          }

          .info-box-b {
            margin-top: 20px;
            .info-box-b-l {
              margin-right: 54px;
            }
            .idcardImg {
              width: 20px;
              height: 17px;
            }
            .phoneImg {
              width: 18px;
              height: 18px;
            }
            span {
              margin-left: 9px;
            }
          }
        }

        .report-box {
          .report-box-item {
            box-sizing: border-box;
            width: 33%;

            .report-box-title {
              font-size: 20px;
              color: #31bfc5;
              margin-left: 30px;
              border-bottom: 2px solid #31bfc5;
              padding-bottom: 15px;
            }
            .report-box-bottom {
              height: calc(100vh - 360px);
              overflow: auto;
              margin-left: 30px;
              margin-top: 10px;

              .list-items {
                background-color: #e8ffef;
                border-radius: 18px;
                margin-bottom: 12px;
                padding: 26px 28px 24px 19px;
                cursor: pointer;
                .times {
                  color: #333;
                  margin-right: 8px;
                }

                .contents {
                  width: 100%;
                  // max-width: 250px;
                  margin-top: 5px;
                }
                .tag2 {
                  display: inline-block;
                  padding: 3px 15px;
                  border-radius: 10px;
                  background: #dddddd;
                  font-size: 12px;
                  color: #999;
                }
                .tag2-active {
                  display: inline-block;
                  padding: 3px 15px;
                  border-radius: 10px;
                  background: #348aec;
                  font-size: 12px;
                  color: #fff;
                }

                .tag {
                  display: inline-block;
                  padding: 3px 15px;
                  border-radius: 10px;
                  background: #dddddd;
                  font-size: 12px;
                  color: #999;
                }

                img {
                  width: 60px;
                  height: 60px;
                }
              }
            }
          }
        }
      }
    }
  }
}

.report-box-bottom-b {
  width: 544px;
  height: 110px;
  background: #eafeff;
  border-radius: 18px;
  margin-bottom: 10px;
}

::v-deep .el-dialog__header {
  border-radius: 15px !important;
  padding: 0px !important;
}
::v-deep .el-dialog {
  border-radius: 15px !important;
}

.dialog-box {
  img {
    width: 42px;
    height: 42px;
    margin-right: 20px;
  }
  .dialog-text {
    width: 120px;
    height: 20px;
    font-size: 20px;
    font-weight: 400;
    color: #d89330;
    line-height: 40px;
  }
}

::v-deep .el-collapse-item__header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding-left: 12px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 120px;
  line-height: 28px;
  background-color: #fff;
  color: #303133;
  cursor: pointer;
  border-bottom: 1px solid #ebeef5;
  font-size: 13px;
  font-weight: 500;
  -webkit-transition: border-bottom-color 0.3s;
  transition: border-bottom-color 0.3s;
  outline: 0;
}
</style>
